import type { MapEventBus } from "../../core/MapEventBus";

export class SilosSelection {
  private selectedTarget = new Set<string>();

  constructor(private eventBus: MapEventBus) {
    this.setupListeners();
  }

  private setupListeners() {
    // Listen to click events
    this.eventBus.on("silo:clicked", ({ silo_id }) => {
      console.log("SILO CLICKED");
      this.toggle(silo_id);
    });
  }

  private toggle(silo_id: string) {
    if (this.selectedTarget.has(silo_id)) {
      // Same aircraft - deselect
      this.deselect(silo_id);
    } else {
      // Different aircraft - select
      this.select(silo_id);
    }
  }

  private select(silo_id: string) {
    this.selectedTarget.add(silo_id);
    this.eventBus.emit("silo:selected", { silo_id });
  }

  private deselect(silo_id: string) {
    if (!this.selectedTarget) return;

    this.selectedTarget.delete(silo_id);

    console.log("[SiloSelection] Deselected:", silo_id);
    this.eventBus.emit("silo:deselected", { silo_id });
  }

  // Public API
  getSelected(): string[] | null {
    return Array.from(this.selectedTarget.values());
  }

  isSelected(silo_id: string): boolean {
    return this.selectedTarget.has(silo_id);
  }

  // Programmatic control
  selectSilo(silo_id: string) {
    if (!this.selectedTarget.has(silo_id)) {
      this.select(silo_id);
    }
  }

  deselectAircraft(silo_id: string) {
    this.deselect(silo_id);
  }

  toggleAircraft(silo_id: string) {
    this.toggle(silo_id);
  }

  destroy() {
    this.selectedTarget.clear();
  }
}
